import { useSearchParams } from 'next/navigation';

import { Icon, Wrapper } from './styles';
import { GearProps } from './types';

const Gear = ({ setIsDevToolsOpen }: GearProps) => {
	const searchParams = useSearchParams();

	function onClick() {
		setIsDevToolsOpen(true);
	}

	if (searchParams?.get('devtools') === 'false') {
		return null;
	}

	return (
		<Wrapper onClick={onClick}>
			<Icon />
		</Wrapper>
	);
};

export default Gear;
